// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2217":"b179d3837a47be47","3644":"d52461c319caa941"}[chunkId] + ".js";
};